/* eslint-disable */
export default {
  tollFree: 'Gratuito',
  rcvPmiMeetingTitle: 'Riunione video di {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
